import * as tslib_1 from "tslib";
import { LoadingController, ToastController } from '@ionic/angular';
import { FormControl, Validators } from '@angular/forms';
import { MissionsService } from './missions.service';
import { FileValidator } from 'ngx-material-file-input';
import * as i0 from "@angular/core";
import * as i1 from "@ionic/angular";
import * as i2 from "./missions.service";
export class ToolsService {
    constructor(loadingController, toastCtrl, missionsService) {
        this.loadingController = loadingController;
        this.toastCtrl = toastCtrl;
        this.missionsService = missionsService;
        this.months = [
            { name: "Enero", value: 1 },
            { name: "Febrero", value: 2 },
            { name: "Marzo", value: 3 },
            { name: "Abril", value: 4 },
            { name: "Mayo", value: 5 },
            { name: "Junio", value: 6 },
            { name: "Julio", value: 7 },
            { name: "Agosto", value: 8 },
            { name: "Septiembre", value: 9 },
            { name: "Octubre", value: 10 },
            { name: "Noviembre", value: 11 },
            { name: "Diciembre", value: 12 },
        ];
        this.years = [
            "2022",
            "2023",
            "2024",
            "2025",
            "2026"
        ];
        //Navigation
        this.breadcrumbs = [];
        this.maxFileSize = 2097152; // it's 2 MB (=2 * 2 ** 20).
        this.termAndConditions = true;
    }
    //Function to reset breadcrumbs
    resetBreadCrumbs() {
        this.breadcrumbs = [];
    }
    showLoader(message = 'Cargando...') {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const loading = yield this.loadingController.create({
                message
            });
            return yield loading.present();
        });
    }
    dismissLoader() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return yield this.loadingController.dismiss();
        });
    }
    getTopLoader() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return yield this.loadingController.getTop();
        });
    }
    showErrorToast(msg = 'Error inesperado, verifica tu conexión e intenta de nuevo más tarde') {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const toast = yield this.toastCtrl.create({
                message: msg,
                duration: 5000,
                color: 'danger',
                position: 'top',
                buttons: [
                    {
                        text: 'X',
                        role: 'cancel',
                        handler: () => { }
                    }
                ]
            });
            toast.present();
        });
    }
    showSuccessToast(msg) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const toast = yield this.toastCtrl.create({
                message: msg,
                duration: 5000,
                color: 'success',
                position: 'top',
                buttons: [
                    {
                        text: 'X',
                        role: 'cancel',
                        handler: () => { }
                    }
                ]
            });
            toast.present();
        });
    }
    //Function to format date as DD-MM-AAAA
    formatDate(date) {
        var aux_date = new Date(date);
        var DD = aux_date.getDate() + '';
        if (DD.length == 1)
            DD = '0' + DD;
        var MM = (aux_date.getMonth() + 1) + '';
        if (MM.length == 1)
            MM = '0' + MM;
        return DD + '-' + MM + '-' + aux_date.getFullYear();
    }
    customRegex(nameRe, validator_regex_error_message) {
        return (control) => {
            let reg = new RegExp(nameRe);
            const isValid = reg.test(control.value);
            if (!validator_regex_error_message)
                validator_regex_error_message = "El dato ingresado no es correcto";
            return isValid ? null : { customRegex: { value: control.value, msg: validator_regex_error_message } };
        };
    }
    //Function to format the questions
    formatQuestions(questions) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            var fixedQuestions = [];
            for (let question of questions) {
                //Generic case
                let fixedQuestion = { id: question.id, label: question.label, format: question.question_type, type: 'text', formControl: undefined, options: question.options, src: [], multiple_response: question.multiple_response, filtered_options: [] };
                var validators = [];
                //Special cases
                if (question.question_type == 'text') {
                    fixedQuestion.format = 'input';
                    // Add specific pattern validator from question
                    if (question.validator_regex) {
                        validators.push(this.customRegex(question.validator_regex, question.validator_regex_error_message));
                    }
                }
                else if (question.question_type == 'number' || question.question_type == 'float' || question.question_type == 'amount') {
                    fixedQuestion.format = 'input';
                    fixedQuestion.type = 'number';
                }
                else if (question.question_type == 'product') {
                    fixedQuestion.format = 'autocomplete';
                    fixedQuestion['search_url'] = '/missions/mission_products';
                    fixedQuestion.options = [];
                }
                if (question.options.search_url) {
                    fixedQuestion.options = [];
                    fixedQuestion['search_url'] = question.options.search_url;
                }
                if (question.options.list_url) {
                    var options = yield this.missionsService.getOptionsDjango(question.options.list_url);
                    fixedQuestion.options = options;
                }
                if (question.required)
                    validators.push(Validators.required);
                if (question.question_type == 'number')
                    validators.push(Validators.pattern(/^[0-9]+$/));
                if (question.question_type == 'file')
                    validators.push(FileValidator.maxContentSize(this.maxFileSize));
                fixedQuestion.formControl = new FormControl('', validators);
                if (question.group) {
                    var fixedGroup = fixedQuestions.find(item => item.id == question.group.id);
                    if (fixedGroup)
                        fixedGroup.questions.push(fixedQuestion);
                    else {
                        fixedGroup = { id: question.group.id, format: 'group', questions: [fixedQuestion], multiple_response: question.group.multiple_response };
                        fixedQuestions.push(fixedGroup);
                    }
                }
                else {
                    fixedQuestions.push(fixedQuestion);
                }
            }
            return fixedQuestions;
        });
    }
    //Function that returns true if no question has errors
    validateQuestions(questions) {
        var is_valid = true;
        for (let question of questions) {
            if (question.is_active === false)
                continue;
            if (question.format == 'autocomplete') {
                if (typeof question.formControl.value != "object") {
                    question.formControl.setErrors({ 'notObject': true });
                }
            }
            if (question.format == 'group')
                is_valid = this.validateQuestions(question.questions);
            else if (question.formControl.errors)
                is_valid = false;
            if (!is_valid)
                break;
        }
        return is_valid;
    }
    markAsTouched(questions) {
        for (let question of questions) {
            if (question.format == 'group')
                this.markAsTouched(question.questions);
            else
                question.formControl.markAsTouched();
        }
    }
    //Function to get selected option in select field
    getSelectedOption(question) {
        return question.options.find(item => item.value == question.formControl.value);
    }
    formatCurrency(value) {
        const options = {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        };
        const numberFormat = new Intl.NumberFormat('en-US', options);
        return numberFormat.format(value);
    }
    displayDateInDays(end) {
        let actual_date = new Date();
        let end_date = new Date(end);
        let diff_time = end_date.getTime() - actual_date.getTime();
        let diff_days = Math.abs(diff_time / (1000 * 3600 * 24));
        return Math.ceil(diff_days);
    }
    specialCharactersValidator(control) {
        const nameRegexp = /[¡!@$%*={};':",\/¿?ç]/;
        if (control.value && nameRegexp.test(control.value)) {
            return { invalidName: true };
        }
    }
    formatGoalName(goal_name) {
        // if (/\d/img.test(goal_name))
        //   goal_name = goal_name.replace(/\d/img, "")
        return goal_name;
    }
    optimizeProfileImage(originalImg) {
        return new Promise(function (resolve) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var img = document.createElement('img');
                img.onload = function () {
                    var canvas = document.createElement('canvas');
                    var ctx = canvas.getContext('2d');
                    canvas.width = img.width;
                    canvas.height = img.height;
                    ctx.drawImage(img, 0, 0, img.width, img.height);
                    var dataURI = canvas.toDataURL('image/jpeg', 0.8);
                    resolve(dataURI);
                };
                img.src = originalImg;
            });
        });
    }
}
ToolsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ToolsService_Factory() { return new ToolsService(i0.ɵɵinject(i1.LoadingController), i0.ɵɵinject(i1.ToastController), i0.ɵɵinject(i2.MissionsService)); }, token: ToolsService, providedIn: "root" });
